export const routingConstants = {
    authoringPath: 'authoring',
    monitoringPath: 'monitoring',
    managementPath: 'management',
    overviewPath: 'home',
    adfEntryPath: 'datafactories',
    a365EntryPath: 'workspaces',
    knowledgeCenter: 'knowledgecenter',
    learnPath: 'learn',
    partnerCenter: 'partnercenter',
    copywizard: 'copywizard',
    templates:'templates',
    mappingartifacts: 'mappingartifacts',

    adfMonitoringDashboard: 'monitoringdashboard',

    deprecatedConnectionPath: 'authoring/connection/Connections',
    managementIntegrationRuntimesPath: 'management/integrationruntimes',

    deprecatedWranglingDataflowPath: 'authoring/wranglingdataflow',
    powerqueryPath: 'authoring/powerquery',

    // sub path for monitoring
    dashboard: 'dashboard',
    orchestrate: 'orchestrate',
    explore: 'explore',
    analyze: 'analyze',
    scopeJob: 'scopejob',
    scopeComputes: 'scopecomputes',
    sparkApplication: 'sparkapplication',
    sparkComputes: 'sparkcomputes',
    sqlRequests: 'sqlrequests',
    kqlRequests: 'kqlrequests',
    sqlComputes: 'sqlcomputes',
    kustoPools: 'kustopools',
    alerts: 'alerts',
    recommendations: 'recommendations',
    usage: 'usage',

    pipelineRuns: 'pipelineruns',
    triggerRuns: 'triggerruns',
    integrationRuntimes: 'integrationruntimes',
    dataflowDebug: 'dataflowdebug',
    performanceTuning: 'performancetuning',
    managedVnets: 'managedvirtualnetworks',
    linkconnections: 'linkconnections',
    adfcdcDatamapperRuns: 'cdcdatamapper',

    // subpath for management
    factorySettings: 'factorysettings',
    upgrades: 'upgrades',
    accessControl: 'accesscontrol',
    triggers: 'triggers',
    dataLinkedServices: 'datalinkedservices',
    purview: 'purview',
    fabric: 'fabric',
    sqlpools: 'sqlpools',
    apachesparkpools: 'apachesparkpools',
    kustopools: 'kustopools',
    scopePools: 'scopepools',
    workspacepackages: 'workspacepackages',
    git: 'git',
    globalparameters: 'globalparameters',
    customerManagedKey: 'customerManagedKey',
    credentialList: 'credentialList',
    armtemplate: 'armtemplate',
    airflow: 'airflow',
    apachesparkconfigurations: 'apachesparkconfigurations',
    userdefinedfunctions: 'userdefinedfunctions',
    outboundRules: 'outboundRules'
};
